import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";
import { toast } from "react-toastify";

const contactnumber = "hello@tegalapp.com";
const location = "Abuja, Nigeria";

class Header extends Component {
  menuTrigger() {
    document.querySelector(".menu").classList.toggle("active");
    document.querySelector(".header-bar").classList.toggle("active");
  }
  menuTriggerTwo() {
    document.querySelector(".header-top").classList.toggle("open");
  }
  render() {
    window.addEventListener("scroll", function () {
      var value = window.scrollY;
      if (value > 200) {
        document
          .querySelector(".header-section")
          .classList.add(["header-fixed"], ["fadeInUp"]);
      } else {
        document
          .querySelector(".header-section")
          .classList.remove(["header-fixed"], ["fadeInUp"]);
      }
    });


    return (
      <header className="header-section">
        <div className="header-top open">
          <div className="container">
            <div className="header-top-area">
              <ul className="left">
                <li>
                  <i className="icofont-ui-message"></i>{" "}
                  <span>{contactnumber}</span>
                </li>
                <li>
                  <i className="icofont-location-pin"></i> {location}
                </li>
              </ul>
              <ul className="social-icons d-flex align-items-center">
                <li>
                  <p>Find us on :</p>
                </li>
                <li>
                  <a href="https://facebook.com/tegalapp" className="fb">
                    <i className="icofont-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href="https://x.com/tegalapp/" className="twitter">
                    <i className="icofont-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/tegalapp" className="instagram">
                    <i className="icofont-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.tiktok.com/@tegalapp" className="tiktok">
                  <img className="icofont-tiktok" src="assets/images/tiktok.png" width={15}/>
                  </a>
                </li>
                <li>
                  <a href="https://www.tiktok.com/@tegalapp" className="tiktok">
                  <i className="icofont-youtube"></i>
                  </a>
                </li>
              
              </ul>
            </div>
          </div>
        </div>
        <div className="header-bottom">
          <div className="container">
            <div className="header-wrapper">
              <div className="logo">
                <Link to="/">
                  <img src="assets/images/logo/logo.png" alt="logo" />
                </Link>
              </div>
              <div className="menu-area">
                <ul className="menu">
                  <li>
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li>
                    <NavLink to="/about">About</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact">Contact Us</NavLink>
                  </li>
                  <li>
                    <a href="#" onClick={()=>{
                        toast.warn('Apple app is comming soon...');
                    }}> <img src="assets/images/appstore-comming.png" className="download-btn" /></a>
                  </li>
                  <li>
                    <a href="https://play.google.com/store/apps/details?id=com.syrol.tegal"><img src="assets/images/playstore.png" className="download-btn" /></a>
                  </li>
                </ul>
               
                <div
                  className="header-bar d-lg-none"
                  onClick={this.menuTrigger}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div
                  className="ellepsis-bar d-lg-none"
                  onClick={this.menuTriggerTwo}
                >
                  <i className="icofont-info-square"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
